function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { useEffect, useCallback, useRef, useState } from 'react';
import { NotificationAPI } from '@/apis/NotificationAPI';
import { ConfigurationAPI } from '@/apis/ConfigurationAPI';
import { isValidHttpUrl } from '@/utils';
import Cookies from 'js-cookie';
export var useRbacNotifications = function useRbacNotifications() {
    var subscriptionRef = useRef(null);
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isUserSubscribed = _useState2[0], setIsUserSubscribed = _useState2[1];
    var initializeNotificationSystem = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
        var supported, registration, existingSubscription, _t;
        return _regenerator().w(function (_context) {
            while (1)
                switch (_context.p = _context.n) {
                    case 0:
                        _context.p = 0;
                        supported = 'serviceWorker' in navigator && 'PushManager' in globalThis.window && 'Notification' in globalThis.window;
                        if (supported) {
                            _context.n = 1;
                            break;
                        }
                        return _context.a(2);
                    case 1:
                        _context.n = 2;
                        return navigator.serviceWorker.register('/rbac-sw.js');
                    case 2:
                        registration = _context.v;
                        _context.n = 3;
                        return navigator.serviceWorker.ready;
                    case 3:
                        _context.n = 4;
                        return registration.pushManager.getSubscription();
                    case 4:
                        existingSubscription = _context.v;
                        if (existingSubscription) {
                            subscriptionRef.current = existingSubscription;
                            setIsUserSubscribed(true);
                        }
                        _context.n = 6;
                        break;
                    case 5:
                        _context.p = 5;
                        _t = _context.v;
                        console.error('[RBAC Notifications] Initialization failed:', _t);
                    case 6:
                        return _context.a(2);
                }
        }, _callee, null, [[0, 5]]);
    })), []);
    var getUserId = useCallback(function () {
        try {
            var user = Cookies.get('user');
            var userData = user ? JSON.parse(user) : null;
            if (userData !== null && userData !== void 0 && userData.id) {
                return String(userData.id);
            }
            return null;
        }
        catch (error) {
            console.error('[RBAC Notifications] Failed to parse user cookie:', error);
            return null;
        }
    }, []);
    useEffect(function () {
        initializeNotificationSystem();
    }, [initializeNotificationSystem]);
    useEffect(function () {
        var autoPrompt = /*#__PURE__*/ function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
                var userId, prompted, _t2;
                return _regenerator().w(function (_context2) {
                    while (1)
                        switch (_context2.p = _context2.n) {
                            case 0:
                                _context2.p = 0;
                                if (!(typeof globalThis === 'undefined')) {
                                    _context2.n = 1;
                                    break;
                                }
                                return _context2.a(2);
                            case 1:
                                if ('Notification' in globalThis) {
                                    _context2.n = 2;
                                    break;
                                }
                                return _context2.a(2);
                            case 2:
                                if (!(!globalThis.isSecureContext && globalThis.location.hostname !== 'localhost')) {
                                    _context2.n = 3;
                                    break;
                                }
                                return _context2.a(2);
                            case 3:
                                if (!(Notification.permission !== 'default')) {
                                    _context2.n = 4;
                                    break;
                                }
                                return _context2.a(2);
                            case 4:
                                userId = getUserId();
                                if (userId) {
                                    _context2.n = 5;
                                    break;
                                }
                                return _context2.a(2);
                            case 5:
                                prompted = sessionStorage.getItem('rbac_push_prompt_shown');
                                if (!(prompted === '1')) {
                                    _context2.n = 6;
                                    break;
                                }
                                return _context2.a(2);
                            case 6:
                                sessionStorage.setItem('rbac_push_prompt_shown', '1');
                                _context2.n = 7;
                                return navigator.serviceWorker.ready;
                            case 7:
                                _context2.n = 8;
                                return enablePushNotification();
                            case 8:
                                _context2.n = 10;
                                break;
                            case 9:
                                _context2.p = 9;
                                _t2 = _context2.v;
                                console.warn('[RBAC Notifications] Auto-prompt failed:', _t2);
                            case 10:
                                return _context2.a(2);
                        }
                }, _callee2, null, [[0, 9]]);
            }));
            return function autoPrompt() {
                return _ref2.apply(this, arguments);
            };
        }();
        autoPrompt();
    }, [getUserId]);
    var enablePushNotification = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
        var permission, userId, vapidPublicKey, registration, existing, sub, _t3, _t4;
        return _regenerator().w(function (_context3) {
            while (1)
                switch (_context3.p = _context3.n) {
                    case 0:
                        _context3.p = 0;
                        _context3.n = 1;
                        return Notification.requestPermission();
                    case 1:
                        permission = _context3.v;
                        if (!(permission !== 'granted')) {
                            _context3.n = 2;
                            break;
                        }
                        setIsUserSubscribed(false);
                        return _context3.a(2, false);
                    case 2:
                        userId = getUserId();
                        if (userId) {
                            _context3.n = 3;
                            break;
                        }
                        setIsUserSubscribed(false);
                        return _context3.a(2, false);
                    case 3:
                        vapidPublicKey = process.env.REACT_APP_;
                        if (vapidPublicKey) {
                            _context3.n = 4;
                            break;
                        }
                        setIsUserSubscribed(false);
                        return _context3.a(2, false);
                    case 4:
                        _context3.n = 5;
                        return navigator.serviceWorker.ready;
                    case 5:
                        registration = _context3.v;
                        _context3.n = 6;
                        return registration.pushManager.getSubscription();
                    case 6:
                        existing = _context3.v;
                        _t3 = existing;
                        if (_t3) {
                            _context3.n = 8;
                            break;
                        }
                        _context3.n = 7;
                        return registration.pushManager.subscribe({
                            userVisibleOnly: true,
                            applicationServerKey: convertVapidKey(vapidPublicKey)
                        });
                    case 7:
                        _t3 = _context3.v;
                    case 8:
                        sub = _t3;
                        subscriptionRef.current = sub;
                        setIsUserSubscribed(true);
                        syncSubscription(sub, true, userId)["catch"](function (error) {
                            console.error('[RBAC Notifications] Sync failed:', error);
                        });
                        return _context3.a(2, true);
                    case 9:
                        _context3.p = 9;
                        _t4 = _context3.v;
                        console.error('[RBAC Notifications] Enable failed:', _t4);
                        setIsUserSubscribed(false);
                        return _context3.a(2, false);
                }
        }, _callee3, null, [[0, 9]]);
    })), [getUserId]);
    var disablePushNotification = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
        var userId, registration, existingSubscription, subToDisable, _t5;
        return _regenerator().w(function (_context4) {
            while (1)
                switch (_context4.p = _context4.n) {
                    case 0:
                        _context4.p = 0;
                        userId = getUserId();
                        if (userId) {
                            _context4.n = 1;
                            break;
                        }
                        console.warn('[RBAC Notifications] No user ID found');
                        return _context4.a(2, false);
                    case 1:
                        _context4.n = 2;
                        return navigator.serviceWorker.ready;
                    case 2:
                        registration = _context4.v;
                        _context4.n = 3;
                        return registration.pushManager.getSubscription();
                    case 3:
                        existingSubscription = _context4.v;
                        subToDisable = subscriptionRef.current || existingSubscription;
                        if (!subToDisable) {
                            _context4.n = 6;
                            break;
                        }
                        _context4.n = 4;
                        return subToDisable.unsubscribe();
                    case 4:
                        _context4.n = 5;
                        return syncSubscription(subToDisable, false, userId);
                    case 5:
                        subscriptionRef.current = null;
                        setIsUserSubscribed(false);
                        return _context4.a(2, true);
                    case 6:
                        return _context4.a(2, false);
                    case 7:
                        _context4.p = 7;
                        _t5 = _context4.v;
                        console.error('[RBAC Notifications] Disable failed:', _t5);
                        return _context4.a(2, false);
                }
        }, _callee4, null, [[0, 7]]);
    })), [getUserId]);
    return {
        isUserSubscribed: isUserSubscribed,
        enablePushNotification: enablePushNotification,
        disablePushNotification: disablePushNotification
    };
};
function convertVapidKey(vapidKey) {
    var padding = '='.repeat((4 - vapidKey.length % 4) % 4);
    var base64 = (vapidKey + padding).replaceAll('-', '+').replaceAll('_', '/');
    var rawData = globalThis.window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.codePointAt(i) || 0;
    }
    return outputArray;
}
function syncSubscription(_x, _x2, _x3) {
    return _syncSubscription.apply(this, arguments);
}
function _syncSubscription() {
    _syncSubscription = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5(subscription, isSubscribed, userId) {
        var platformHost, action, _t6;
        return _regenerator().w(function (_context5) {
            while (1)
                switch (_context5.p = _context5.n) {
                    case 0:
                        _context5.n = 1;
                        return ConfigurationAPI.getPlatformHost();
                    case 1:
                        platformHost = _context5.v;
                        if (!(!platformHost || !isValidHttpUrl(platformHost))) {
                            _context5.n = 2;
                            break;
                        }
                        console.error('[RBAC Notifications] Invalid PLATFORM_HOST URL');
                        return _context5.a(2);
                    case 2:
                        _context5.p = 2;
                        _context5.n = 3;
                        return NotificationAPI.syncSubscription(subscription, isSubscribed, userId, platformHost);
                    case 3:
                        _context5.n = 5;
                        break;
                    case 4:
                        _context5.p = 4;
                        _t6 = _context5.v;
                        action = isSubscribed ? 'Registration' : 'Unregistration';
                        console.error("[RBAC Notifications] ".concat(action, " failed:"), _t6);
                    case 5:
                        return _context5.a(2);
                }
        }, _callee5, null, [[2, 4]]);
    }));
    return _syncSubscription.apply(this, arguments);
}
